<template>
    <!--  functional-->
    <div class="show-model-position">
        <el-row class="position-row">
            <el-col :span="6">
                <div class="view-item" style="font-weight: 700">{{ fileTitle || '已选文件视图：' }}</div>
            </el-col>
            <el-col :span="4">
                <div class="view-item" style="color: #999999">X方向偏移量</div>
            </el-col>
            <el-col :span="4">
                <div class="view-item" style="color: #999999">Y方向偏移量</div>
            </el-col>
            <el-col :span="4">
                <div class="view-item" style="color: #999999">Z方向偏移量</div>
            </el-col>
            <el-col :span="4">
                <div class="view-item" style="color: #999999">模型旋转角度</div>
            </el-col>
            <el-col v-if="isShowOperate" :span="2">
                <div class="view-item" style="color: #999999">操作</div>
            </el-col>
        </el-row>
        <!-- v-if="data" -->
        <el-row class="position-row" v-for="(item, index) in data" :key="index">
            <el-col :span="6">
                <div class="view-item view-item-name" :title="item.displayName">{{ item.displayName }}</div>
            </el-col>
            <el-col :span="4">
                <div class="view-item">
                    X：
                    <el-input
                        size="mini"
                        min="0"
                        type="string"
                        v-model.trim="item.x"
                        @input="updateView"
                        @keyup.native="validate($event)"
                        placeholder="请输入偏移量"
                    ></el-input>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="view-item">
                    Y：
                    <el-input
                        size="mini"
                        min="0"
                        type="string"
                        v-model.trim="item.y"
                        @input="updateView"
                        @keyup.native="validate($event)"
                        placeholder="请输入偏移量"
                    ></el-input>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="view-item">
                    Z：
                    <el-input
                        size="mini"
                        min="0"
                        type="string"
                        v-model.trim="item.z"
                        @input="updateView"
                        @keyup.native="validate($event)"
                        placeholder="请输入偏移量"
                    ></el-input>
                </div>
            </el-col>
            <el-col :span="isShowOperate ? 4 : 5">
                <div class="view-item">
                    R：
                    <el-input-number
                        size="mini"
                        :min="0"
                        :max="360"
                        type="string"
                        v-model.trim="item.r"
                        @input="updateView"
                        @keyup.native="validate($event)"
                        placeholder="请输入模型旋转角度"
                    ></el-input-number>
                </div>
            </el-col>
            <el-col v-if="isShowOperate" :span="2"
                ><i @click="removeView && removeView(item)" class="view-item view-item-icon el-icon-delete"></i
            ></el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: {
        fileTitle: '',
        removeView: {},
        isShowOperate: '',
        data: {
            default: () => [],
        },
    },
    methods: {
        // https://www.cnblogs.com/xhliang/p/11940418.html
        // element-ui input组件无法输入值
        updateView(e) {
            this.$forceUpdate();
        },
        validate(e) {
            let num = /[0-9]/;
            if (
                e.key !== '.' &&
                !num.test(e.key) &&
                e.key !== 'Backspace' &&
                e.key !== 'Tab' &&
                e.key !== 'Shift' &&
                e.key !== 'NumLock' &&
                e.key !== 'CapsLock' &&
                e.key !== 'Control' &&
                e.key !== 'Enter'
            ) {
                this.$message({
                    message: '不能输入非法字符',
                    type: 'warning',
                });
            }
        },
    },
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
$color-bgc = #f7f7f7
.show-model-position
  width 100%
  margin-top 10px
  .position-row:nth-child(even)
    background-color $color-bgc
    border 1px solid $color-bgc
  .view-item
    display flex
    margin 5px 0
    padding-left 10px
    line-height 28px
    height 28px
    vertical-align middle
  .view-item-name
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
    word-break break-all
    width 100%
  .view-item-icon
    cursor pointer
    padding-left 20px
  .view-item-icon:hover
    color #e81a1a
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/ModelAssemble/ShowModelPosition.vue